import { html } from "lit-element";
import { DrawSVGTextBaseModule } from "../../ModuleBase/svg-text-base-module";

export class DrawKeukenblokMagentaModule extends DrawSVGTextBaseModule {
	constructor(canvas) {
		super(canvas, "Keukenblok");

		this.name = "keukenblok-magenta";
		this.icon = svg_keukenblok_magenta;
		this.svgTextIndex = 5;
	}
}

window.customElements.define("inspx-draw-keukenblok-magenta-module", DrawKeukenblokMagentaModule);

const svg_keukenblok_magenta = (text) => html`
<svg xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" width="25.703865mm" height="11.656082mm" viewBox="0 0 25.703865 11.656082">
    <defs id="defs2356" />
    <g transform="translate(-100.54092,-124.10648)">
        <g id="g6220" transform="matrix(0.26458333,0,0,0.26458333,4.7615704,30.546026)">
            <rect ry="0" y="354.09683" x="362.48322" height="43.089481" width="96.183464" id="rect6156" style="fill:#ff00ff;fill-opacity:0.98843934;stroke:#021801;stroke-width:0.96500343;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
            />
            <rect ry="4.6636977" y="362.98587" x="381.85202" height="17.100225" width="28.805494" id="rect6158" style="fill:#ff00ff;fill-opacity:0.98843934;stroke:#021801;stroke-width:1.07466543;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
            />
            <path id="path6188" d="m 429.86117,362.98588 h 19.20366" style="fill:none;stroke:#000000;stroke-width:0.9060725px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            />
            <path id="path6190" d="m 429.86117,371.53599 h 19.20366" style="fill:none;stroke:#000000;stroke-width:0.9060725px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            />
            <path id="path6192" d="m 429.86117,380.0861 h 19.20366" style="fill:none;stroke:#000000;stroke-width:0.9060725px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            />
            <text transform="scale(0.7599368,1.3158989)" id="text6200" y="299.60385" x="488.69159" style="font-style:normal;font-variant:normal;font-weight:bold;font-stretch:normal;font-size:12.80000019px;line-height:0%;font-family:Arial;-inkscape-font-specification:'Arial Bold';text-align:start;writing-mode:lr-tb;text-anchor:start;fill:#000000;fill-opacity:1;stroke:none;stroke-width:1.06666672"
                xml:space="preserve">
                <tspan y="299.60385" x="488.69159" id="tspan6202" style="font-size:12.63503933px;line-height:1.25;stroke-width:1.06666672">${text}</tspan>
            </text>
        </g>
    </g>
</svg>`;
